import { goTo } from "../../../utils";
import ButtonAnchor from "../../common/button-anchor/button-anchor";
import "./self-employed-page-info.sass";

const SelfEmployedFormPageInfo = () => {
  return (
    <div className="self-employed-page-info">
      <div className="self-employed-page-info__block">
        <div className="self-employed-page-info__title">
          Регистрация в системе самозанятости CREON состоит всего из 3 шагов:
        </div>
        <ul className="self-employed-page-info__list">
          <li className="self-employed-page-info__item">
            отправить нам данные через форму на сайте
          </li>
          <li className="self-employed-page-info__item">
            получить Соглашение (в двух вариантах) и подписать его через ЭДО
            (простой электронной подписью — ПЭП)
          </li>
          <li className="self-employed-page-info__item">
            получить Договор (в двух вариантах) и подписать его через ЭДО
            (простой электронной подписью — ПЭП)
          </li>
        </ul>
      </div>

      <div className="self-employed-page-info__block">
        <div className="self-employed-page-info__title">Важно: </div>
        <ul className="self-employed-page-info__list">
          <li className="self-employed-page-info__item">
            Необходимо подписать два Соглашения и два Договора — без этого
            регистрация считается не действительной
          </li>
          <li className="self-employed-page-info__item">
            Договор придет на почту только после подписания обоих Соглашений
          </li>
          </ul>
      </div>

      <ButtonAnchor
        className="self-employed-page-info__button"
        onClick={() => goTo("#form")}
      >
        Зарегистрироваться
      </ButtonAnchor>
    </div>
  );
};

export default SelfEmployedFormPageInfo;
